export default __webpack_public_path__ + "static/media/rocks.5c43bb8f.png";